/* eslint-disable react/display-name */
import { useContext, useState } from 'react'

import { PopupDanger } from '@hhgtech/hhg-components'
// import { useAuthRequiredAction } from 'hooks/useAuthRequiredAction'
// import { useRouter } from 'next/router'
// import { callApiWithAuth } from 'api/utils'
// import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'
// import { TogetherDataContext } from 'state/togetherData'
// import { PostActions } from 'state/togetherData/postReducer'

// import { callApiWithAuth, getTogetherPath } from '../../../api/utils'
// import { PATHS } from '../api/paths'
// import { useDeletePost, useFollowUnfollowPost } from '../hooks/usePostAction'
// import { PATHS } from '../api/paths'
// import { getTogetherPath } from '../api/utils'
// import { TogetherDataContext } from '../common/TogetherDataWrapper'
import { useDeletePost } from '../common/TogetherDataWrapper/hooks/usePostAction'
// import { PostActions } from '../common/TogetherDataWrapper/state/postReducer'
import More from '../icons/More'
import { REPORT_REASON_MAP, TRACKING_CATEGORY } from '../interfaces/constant'
import { Post } from '../interfaces/types'
import { TreePopoverMenu } from '../popoverMenu/treePopoverMenu'
import { SubmitReportForm } from '../submitReportForm'
import { StyledSharePopup } from './index.styled'

export type Props = {
  url?: string
  className?: string
  popoverClassName?: string
  authorId?: string
  authorEmail?: string
  onDeletePost?: (postId: string) => void
  onEditPost?: (post: Post) => void
  shareUrl?: string
  post?: Post
  isMobile?: boolean
  redirectToSSOWithReturnUrl?: () => void
}

export const CardPostPopoverMore = ({
  url,
  authorEmail,
  onDeletePost: onDeletePostProps,
  // onDeletePost,
  onEditPost,
  shareUrl,
  post,
  className = '',
  popoverClassName = '',
  redirectToSSOWithReturnUrl,
}: Props) => {
  const { formatMessage: f } = useIntl()
  // const { locale = 'vi-VN' } = useRouter()
  const {
    state,
    // pushNotifications
  } = useContext(AppContext)
  const { userInfo, isLoggedIn } = state
  const [isOpenLeavePopup, setIsOpenLeavePopup] = useState(false)
  const [isOpenSharePopup, setIsOpenSharePopup] = useState(false)
  // const [isOpenEditPopup, setIsOpenEditPopup] = useState(false)
  // const { authActionWrapper } = useAuthRequiredAction()
  // const { loading, onFollowUnfollowPost } = useFollowUnfollowPost()

  const { onDeletePost } = useDeletePost()

  // const { dispatch: togetherDataDispatch } = useContext(TogetherDataContext)
  const isAuthor =
    authorEmail && userInfo?.email && authorEmail === String(userInfo?.email)
  return (
    <>
      <div
        className={className}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        {isOpenSharePopup && (
          <StyledSharePopup
            url={shareUrl}
            trackingCategory={TRACKING_CATEGORY}
            text={post?.title}
            onClose={() => setIsOpenSharePopup(false)}
          />
        )}
        {isOpenLeavePopup && (
          <PopupDanger
            thumbnail={'/askDoctor/delete.svg'}
            isThumbnailIcon
            title={f({
              id: 'popup.deletePost.title',
              defaultMessage: 'Bạn có chắc không?',
            })}
            description={f({
              id: 'popup.deletePost.description',
              defaultMessage: 'Xoá bài đăng của bạn không thể thay đổi được',
            })}
            acceptText={f({
              id: 'popup.deletePost.accept',
              defaultMessage: 'Xóa',
            })}
            cancelText={f({
              id: 'popup.deletePost.cancel',
              defaultMessage: 'Tắt',
            })}
            onAccept={async () => {
              if (!post?.id) return
              const res = await onDeletePost(post.id)
              if (res) onDeletePostProps?.(post.id)
            }}
            // onAccept={async () => {
            //   // if (!post?.id) return
            //   // const res = await onDeletePost(post.id)
            //   // if (res) onDeletePostProps && onDeletePostProps()
            // }}
            onClose={() => setIsOpenLeavePopup(false)}
          />
        )}
        <TreePopoverMenu
          className={popoverClassName}
          toggleButtonContent={
            <More />
            // <img loading="lazy" src={'./askDoctor/moreSolid.svg'} alt="more" />
          }
          position="bottom"
          align="end"
          data={
            isAuthor
              ? {
                  isShowheader: false,
                  type: 'list',
                  list: [
                    // {
                    //   icon: '/askDoctor/icon-share-on-media.svg',
                    //   label: f({ id: 'morePopover.share' }),
                    //   dataEventCategory: TRACKING_CATEGORY,
                    //   dataEventAction: 'Share Text Click',
                    //   dataEventLabel: url,
                    //   onClick: () => setIsOpenSharePopup(true),
                    // },
                    {
                      icon: '/askDoctor/icon-tab-edit-2.svg',
                      label: f({ id: 'actionPopover.edit' }),
                      onClick: () => {
                        post?.id && onEditPost?.(post)
                        setIsOpenLeavePopup(false)
                      },
                    },
                    {
                      icon: '/askDoctor/icon-trash-bin.svg',
                      label: f({ id: 'actionPopover.delete' }),
                      onClick: () => {
                        // authActionWrapper(() => {
                        setIsOpenLeavePopup(true)
                        // })
                      },
                    },
                  ],
                }
              : {
                  isShowheader: false,
                  type: 'list',
                  list: [
                    // {
                    //   icon: '/askDoctor/icon-share-on-media.svg',
                    //   label: f({ id: 'morePopover.share' }),
                    //   dataEventCategory: TRACKING_CATEGORY,
                    //   dataEventAction: 'Share Text Click',
                    //   dataEventLabel: url,
                    //   onClick: () => setIsOpenSharePopup(true),
                    // },
                    // {
                    //   icon: !!post?.bookmarked
                    //     ? '/askDoctor/icon-bookmark-fill.svg'
                    //     : '/askDoctor/icon-bookmark.svg',
                    //   label: !!post?.bookmarked
                    //     ? f({ id: 'morePopover.unsavePost' })
                    //     : f({ id: 'morePopover.savePost' }),
                    //   dataEventCategory: TRACKING_CATEGORY,
                    //   dataEventAction: 'Save Post Click',
                    //   dataEventLabel: url,
                    //   onClick: () => {
                    //     ;(async () => {
                    //       !isLoggedIn && redirectToSSOWithReturnUrl?.()
                    //       if (!userInfo?.id || !post?.id) return
                    //       if (post?.bookmarked) {
                    //         const res = await callApiWithAuth(
                    //           getTogetherPath(PATHS.BOOKMARK.DELETE, {
                    //             _locale: locale,
                    //             postId: post?.id,
                    //           }),
                    //           'DELETE',
                    //           {
                    //             data: {
                    //               post_id: String(post.id),
                    //             },
                    //           },
                    //         )
                    //         if (res?.status === 1) {
                    //           pushNotifications({
                    //             title: '',
                    //             message: 'Removed saved post',
                    //             type: 'success',
                    //             displayIcon: '/askDoctor/icon-bookmark.svg',
                    //           })
                    //           togetherDataDispatch({
                    //             type: PostActions.update,
                    //             payload: {
                    //               id: post.id,
                    //               data: {
                    //                 bookmarked: false,
                    //               },
                    //             },
                    //           })
                    //         } else {
                    //           pushNotifications({
                    //             title: '',
                    //             message: 'Remove failed',
                    //             type: 'danger',
                    //             displayIcon: '/askDoctor/icon-bookmark.svg',
                    //           })
                    //         }
                    //       } else {
                    //         const res = await callApiWithAuth(
                    //           getTogetherPath(PATHS.BOOKMARK.CREATE, {
                    //             _locale: locale,
                    //           }),
                    //           'POST',
                    //           {
                    //             data: {
                    //               post_id: post.id,
                    //             },
                    //           },
                    //         )
                    //         if (res?.status === 1) {
                    //           pushNotifications({
                    //             title: '',
                    //             message: 'Post saved',
                    //             type: 'success',
                    //             displayIcon:
                    //               '/askDoctor/icon-bookmark-fill.svg',
                    //           })
                    //           togetherDataDispatch({
                    //             type: PostActions.update,
                    //             payload: {
                    //               id: post.id,
                    //               data: {
                    //                 bookmarked: true,
                    //               },
                    //             },
                    //           })
                    //         } else {
                    //           pushNotifications({
                    //             title: '',
                    //             message: 'Post saved failed',
                    //             type: 'danger',
                    //             displayIcon: '/askDoctor/icon-bookmark.svg',
                    //           })
                    //         }
                    //       }
                    //     })()
                    //   },
                    // },
                    // {
                    //   icon: ('/askDoctor/icon-bell-on.svg'),
                    //   label: !hasNotification
                    //     ? f({ id: 'morePopover.turnOnNotifications' })
                    //     : f({ id: 'morePopover.turnOffNotifications' }),
                    //   onClick: () => {
                    //     authActionWrapper(async () => {
                    //   if (!post?.id) return
                    //   const res = await onFollowUnfollowPost({
                    //     id: post?.id,
                    //     followValue: !localHasNoti,
                    //   })
                    //   if (res) setLocalHasNoti((v) => !v)
                    // })
                    //   },
                    // },
                    {
                      icon: '/askDoctor/icon-alert-circle.svg',
                      label: f({ id: 'morePopover.report' }),
                      onClick: () => {
                        !isLoggedIn && redirectToSSOWithReturnUrl?.()
                      },
                      subTree: {
                        title: f({ id: 'morePopover.report.title' }), //'Report this post',
                        description: f({
                          id: 'morePopover.report.description',
                        }), // 'Help us understand what’s happening with this post. How would you describe it?',
                        isShowheader: true,
                        type: 'list',
                        list: Object.keys(REPORT_REASON_MAP)
                          .map((k) => ({
                            label: REPORT_REASON_MAP[k].label,
                            reason: REPORT_REASON_MAP[k].reportReasonText,
                            reasonValue: k,
                          }))
                          .map((item) => ({
                            label: f({ id: item.label }),
                            subTree: {
                              title: f({
                                id: 'morePopover.reportSubmit.title',
                              }), //'Submit report?',
                              description: f({
                                id: 'morePopover.reportSubmit.description',
                              }), //'We won’t tell them who reported it. Please check these details:',
                              isShowheader: true,
                              type: 'jsx',
                              jsxRenderer: (setShow) => (
                                <SubmitReportForm
                                  reason={item.reasonValue}
                                  reasonText={f({ id: item.reason })}
                                  postId={post?.id || ''}
                                  onClose={() => setShow && setShow(false)}
                                />
                              ),
                            },
                          })),
                      },
                      dataEventCategory: TRACKING_CATEGORY,
                      dataEventAction: 'Report Post',
                      dataEventLabel: url,
                    },
                  ],
                }
          }
          buttonProps={
            {
              // isLoading: loading,
            }
          }
        />
      </div>
    </>
  )
}
